"use client";

import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { LayoutContext } from "../layout-context-container";
import Modal from "../modal";
import Button from "../button";
import { useRouter } from "next/router";

function Interstitial() {
  const router = useRouter();
  const modalRef = useRef(null);
  const [isHcp, setIsHcp] = useState(false);
  const {
    setShowMobileMenu,
    interstitialStateOpen,
    setInterstitialStateOpen,
    interstitialLeaveSite,
    interstitialHref,
    interstitialActionLabel,
    setInterstitialActionLabel,
    isHcpRoute,
  } = useContext(LayoutContext);

  useEffect(() => {
    if (interstitialStateOpen) {
      modalRef.current?.open();
      setTimeout(() => {
        const button = document.getElementById('interstitial__buttons__leave');
        button?.focus();

      }, 333);
    } else {
      modalRef.current?.close();
      setInterstitialActionLabel(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interstitialStateOpen]);

  function handleLeaveSite(){
    setShowMobileMenu(false);
    setInterstitialStateOpen(false);
  }

  useEffect(() => {
    router.isReady && setIsHcp(isHcpRoute);
  }, [router.isReady, isHcpRoute]);

  const containerClass = useMemo(() => {
    let className = 'interstitial__modal';

    if (interstitialLeaveSite) {
      className = `${className} interstitial__modal--leave-site`
    }

    return className;
  }, [interstitialLeaveSite])

  return (
    <Modal
      ref={modalRef}
      showCloseButton={true}
      customClass={containerClass}
    >
      {!interstitialLeaveSite && <>
        {isHcp && <>
          <span className='interstitial__header'>Are you a healthcare professional?</span>
          <span className="interstitial__body">
            The information provided in this section is intended for healthcare professionals in 
            the United States. Click “Yes, I am” to enter if you are a U.S. healthcare professional.
          </span>
        </>}
        {!isHcp && <>
          <span className="interstitial__body text-[white] mt-14 !text-[1rem] mobile-down:!text-[1.375rem]">
            This website contains information intended for US healthcare professionals only. Are you a US healthcare professional?
          </span>
        </>}
      </>}
      
      {interstitialLeaveSite && <>
        {isHcp && <span className='interstitial__header text-center'>
          You are now leaving the CRENESSITY<sup>&reg;</sup> (crinecerfont) website
        </span>}
        {!isHcp && <span className='interstitial__header text-center !text-[white] inline-block !text-center !text-[1.25rem] mobile-down:!text-[1.75rem] !mt-12 !leading-[1.2] max-w-[400px] mx-auto'>
          You are now leaving the CRENESSITY website
        </span>}
      </>}
      
      <div className='interstitial__buttons'>
        {!interstitialLeaveSite && isHcp && <><Button
          type="button"
          onClick={() => setInterstitialStateOpen(false)}
          id="interstitial__buttons__leave"
          variant="outline-transparent"
          data-gtm-event-category="Internal Link"
          data-gtm-event-action="Click"
          data-gtm-event-label="Yes, I am a healthcare professional"
        >
          Yes, I am
        </Button>
        <Button
          variant="outline-transparent"
          onClick={handleLeaveSite}
          href={interstitialHref}
          targetBlank
          data-gtm-event-category="External Link"
          data-gtm-event-action="Click"
          data-gtm-event-label="No, I'm not a healthcare professional"
        >
          No, I’m not
        </Button></>}

        {!interstitialLeaveSite && !isHcp && <><Button
          onClick={handleLeaveSite}
          variant={['outline--eggplant', 'dtc-big']}
          id="interstitial__buttons__leave"
          targetBlank
          href={interstitialHref}
          data-gtm-event-category="External Link"
          data-gtm-event-action="Click"
          data-gtm-event-label="Yes, I am a healthcare professional"
          customClass="interstitial__buttons__dtc"
        >
          Yes
        </Button>
        <Button
          type="button"
          variant={['solid--eggplant', 'dtc-big']}
          onClick={() => setInterstitialStateOpen(false)}
          data-gtm-event-category="Internal Link"
          data-gtm-event-action="Click"
          data-gtm-event-label="No"
          customClass="interstitial__buttons__dtc"
        >
          No
        </Button></>}

        {interstitialLeaveSite && isHcp && <><Button
          onClick={handleLeaveSite}
          id="interstitial__buttons__leave"
          variant="outline-transparent"
          targetBlank
          href={interstitialHref}
          data-gtm-event-category="External Link"
          data-gtm-event-action="Click"
          data-gtm-event-label={`Leave Site - ${interstitialActionLabel !== undefined ? interstitialActionLabel : interstitialHref}`}
        >
          Leave site
        </Button>
        <Button
          type="button"
          variant="outline-transparent"
          onClick={() => setInterstitialStateOpen(false)}
          data-gtm-event-category="External Link"
          data-gtm-event-action="Click"
          data-gtm-event-label={`Stay on site - ${interstitialActionLabel !== undefined ? interstitialActionLabel : interstitialHref}`}
        >
          Stay on site
        </Button></>}

        {interstitialLeaveSite && !isHcp && <><Button
          onClick={handleLeaveSite}
          id="interstitial__buttons__leave"
          variant={['outline--eggplant', 'dtc-big']}
          targetBlank
          href={interstitialHref}
          data-gtm-event-category="External Link"
          data-gtm-event-action="Click"
          data-gtm-event-label={`yes - ${interstitialHref}`}
          customClass="interstitial__buttons__dtc"
        >
          Yes
        </Button>
        <Button
          type="button"
          variant={['solid--eggplant', 'dtc-big']}
          onClick={() => setInterstitialStateOpen(false)}
          data-gtm-event-category="External Link"
          data-gtm-event-action="Click"
          data-gtm-event-label={`No - ${interstitialHref}`}
          customClass="interstitial__buttons__dtc"
        >
          No
        </Button></>}
      </div>
    </Modal>
  );
}

export default Interstitial;